export const MONTHS = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'];
export const MONTHS_S = ['янв', 'фев', 'мар', 'апр', 'май', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек'];
export const WDAYS_MON = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'];
export const WDAYS_SUN = ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'];
export const CURRENCIES = [
    { code: 'RUB', sym: '₽' },
    { code: 'USD', sym: '$' },
    { code: 'EUR', sym: '€' },
    { code: 'GBP', sym: '£' },
    { code: 'KZT', sym: '₸' },
    { code: 'BYN', sym: 'Br' },
    { code: 'UAH', sym: '₴' },
];
export const DEFAULT_CATS = [
    { id: 'salary', label: 'Зарплата', icon: '💼', type: 'income' },
    { id: 'freelance', label: 'Фриланс', icon: '💻', type: 'income' },
    { id: 'gift', label: 'Подарок', icon: '🎁', type: 'income' },
    { id: 'invest', label: 'Инвестиции', icon: '📈', type: 'income' },
    { id: 'food', label: 'Продукты', icon: '🛒', type: 'expense' },
    { id: 'cafe', label: 'Кафе', icon: '☕', type: 'expense' },
    { id: 'transport', label: 'Транспорт', icon: '🚗', type: 'expense' },
    { id: 'home', label: 'Жильё', icon: '🏠', type: 'expense' },
    { id: 'health', label: 'Здоровье', icon: '💊', type: 'expense' },
    { id: 'fun', label: 'Развлечения', icon: '🎬', type: 'expense' },
    { id: 'clothes', label: 'Одежда', icon: '👗', type: 'expense' },
    { id: 'edu', label: 'Образование', icon: '📚', type: 'expense' },
    { id: 'other', label: 'Прочее', icon: '📦', type: 'expense' },
];
export const BUDGET_ICONS = ['💼', '💰', '🏠', '🚗', '✈️', '🎓', '💊', '🛒', '🎬', '📱', '🍕', '☕', '🌟', '💎', '📊', '🎯', '🏖', '🎸', '🐾', '🌿'];
export const DEFAULT_SAVINGS_CATS = [
    { id: 'savings_goal1', label: 'Цель 1', icon: '🎯', type: 'savings' },
];
